import { Text } from "@certn/cascadia";

const CAPACITY = 3;

interface PackageChecksProps {
  checks: string[];
  testID: string;
}

export function PackageChecks({ checks, testID }: PackageChecksProps) {
  return (
    <div>
      <Text
        style="global/info-label"
        color="text-weak"
        testID={`${testID}-package-checks`}
      >
        {checks.slice(0, CAPACITY).join(", ")}
      </Text>
      {checks.length > CAPACITY && (
        <Text
          style="global/info-label"
          color="text-weak"
          testID={`${testID}-package-checks-overflow`}
        >
          {` +${checks.length - CAPACITY}`}
        </Text>
      )}
    </div>
  );
}
